import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import classNames from 'classnames';
import { render, unmount } from 'rc-util/lib/React/render';
import React, { useEffect } from 'react';
import { ILoadingProps } from '../types/loading';
import './index.less';

interface LoadingComponent extends React.FC<ILoadingProps> {
    show: (tip?: string) => void;
    hidden: () => void;
}

export const createLoading = () => {
    const Loading: LoadingComponent = (props) => {
        const { tip, allowClickMask = false, className, style } = props;

        useEffect(() => {
            disableBodyScroll(document.body, {
                reserveScrollBarGap: true,
            });
            return () => enableBodyScroll(document.body);
        }, []);

        return (
            <div
                className={classNames('xdesign-loading', className)}
                style={{ ...style, minWidth: tip ? 100 : 'auto' }}
            >
                {/* body禁止用户操作body */}
                {allowClickMask ? null : (
                    <style
                        dangerouslySetInnerHTML={{
                            __html: `html, body {
                          user-select: none;
                          pointer-events: none;
                      }`,
                        }}
                    />
                )}

                <div className="xdesign-loading__wrap">
                    <span className="xdesign-loading__content"></span>
                </div>

                {tip ? <div className="xdesign-loading__tip">{tip}</div> : null}
            </div>
        );
    };

    let el: HTMLDivElement | null = null;

    const show: LoadingComponent['show'] = (tip) => {
        if (!el) {
            el = document.createElement('div');
        }
        document.body.appendChild(el);
        render(<Loading tip={tip} />, el);
    };

    const hidden: LoadingComponent['hidden'] = () => {
        if (el && el.parentNode) {
            unmount(el);
            el.parentNode.removeChild(el);
            el = null;
        }
    };

    Loading.show = show;
    Loading.hidden = hidden;

    return Loading;
};

const Loading = createLoading();

export default Loading;
